import { useEffect, useState } from 'react';

/**
 * useMediaQuery (additive) — CSS 미디어 쿼리의 현재 매칭 여부를 구독한다.
 *
 * `useAutoCollapseSidebar` 가 전역 NavBar 전용으로 쓰던 matchMedia 패턴을, 폭에 반응하는
 * 다른 패널(캘린더 3열 셸의 좌측 사이드바 등)도 쓸 수 있도록 일반화한 것이다.
 * 기존 훅은 그대로 두고 신규 소비자만 이쪽을 쓴다(회귀 0).
 *
 *   - matchMedia 미지원 환경(jsdom 폴리필 이전, SSR)은 항상 false → 호출부는 기본값 경로.
 *   - Safari 14 미만은 addEventListener 미지원 → addListener 폴백.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mql = window.matchMedia(query);
    setMatches(mql.matches);

    const onChange = (e: MediaQueryListEvent) => setMatches(e.matches);
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, [query]);

  return matches;
}
